import React from 'react';
import { BookOpenIcon, CreditCardIcon, GiftIcon, MailCheckIcon, UsersIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from './CTAButton';
const BONUS_ITEMS = ['Bono 1: Guía Express de Configuración Perfecta para iPhone', 'Bono 2: Checklist de Seguridad y Privacidad para Proteger tu iPhone', 'Bono 3: Mini Guía de Trucos Ocultos para Ahorrar Tiempo con tu iPhone', 'Bono 4: Plantilla de Organización Digital para iPhone', 'Bono 5: Manual Rápido de Cámara iPhone para Fotos y Videos Más Profesionales'];
const INCLUDES = [{
  icon: CreditCardIcon,
  title: 'Paga con Mercado Pago',
  description: 'Pago simple y seguro con la plataforma que ya conoces.'
}, {
  icon: MailCheckIcon,
  title: 'Acceso inmediato vía mail',
  description: 'Recibes todo en tu correo apenas confirmas la compra.'
}, {
  icon: UsersIcon,
  title: 'Acceso a mi comunidad de clientes VIP',
  description: 'Novedades, trucos nuevos y soporte entre usuarios como tú.'
}, {
  icon: GiftIcon,
  title: 'También te llevas 5 bonos de regalo',
  description: 'Configuración, seguridad, trucos, organización y cámara.'
}];
export function OfferStack() {
  return <Section id="comprar" className="bg-ink-950" data-id="element-168" data-mp="1egzns8eu9865">
      <SectionTitle eyebrow="La oferta" data-id="element-169" data-mp="1je98jara8vnn">
        Esto es exactamente lo que recibes hoy
      </SectionTitle>

      <div className="overflow-hidden rounded-[2rem] border border-accent/25 bg-ink-900 p-6 sm:p-9" data-id="element-170" data-mp="lr95dn66bk48">
        <div className="flex flex-col gap-4 rounded-3xl border border-white/10 bg-ink-950 p-5 sm:flex-row sm:items-center" data-id="element-171" data-mp="qqddsbl9xdti">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-accent/15" data-id="element-172" data-mp="vn3sovlce3dc">
            <BookOpenIcon className="h-5 w-5 text-accent-soft" aria-hidden="true" data-id="element-173" data-mp="znw3ht9v4gbq" />
          </span>
          <div data-id="element-174" data-mp="275n2fl530zaq">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/40" data-id="element-175" data-mp="2b55m6dl634bz">
              Libro principal
            </p>
            <p className="mt-1 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-176" data-mp="bzmbvn3dnc4r">
              iPhone Experto: Trucos, Ajustes y Secretos para Usar tu iPhone
              como un Profesional
            </p>
          </div>
        </div>

        <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-177" data-mp="kyzogomssgtp">
          {INCLUDES.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex items-start gap-4 rounded-3xl border border-white/8 bg-ink-950/60 p-5" data-id="element-178" data-mp="3ohsorzqkf95x">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-accent/15" data-id="element-179" data-mp="3khsb4hbaj1zx">
                <Icon className="h-5 w-5 text-accent-soft" aria-hidden="true" data-id="element-180" data-mp="23j15sugm567" />
              </span>
              <div data-id="element-181" data-mp="3tfkmjadw5pi1">
                <p className="text-sm font-bold text-white sm:text-base" data-id="element-182" data-mp="35rb8wvqu081z">
                  {title}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-white/55 sm:text-sm" data-id="element-183" data-mp="30srlss0i4q81">
                  {description}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mt-4 rounded-3xl border border-white/8 bg-ink-950/60 p-5 sm:p-6" data-id="element-184" data-mp="1l1fla5ngwacr">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/40" data-id="element-185" data-mp="179r9k3h4rnwb">
            Tus 5 bonos incluidos
          </p>
          <ul className="mt-4 space-y-3" data-id="element-186" data-mp="1c9ndy3tqphce">
            {BONUS_ITEMS.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-white/70" data-id="element-187" data-mp="1zxwxez3hdt0d">
                <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-soft" aria-hidden="true" data-id="element-188" data-mp="23xnrpcs7ur9n" />
                <span data-id="element-189" data-mp="1uyafwdgmdqlr">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-6 rounded-3xl border border-accent/30 bg-accent/[0.07] p-6 text-center sm:p-8" data-id="element-190" data-mp="ekkb14hoeyb2">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent-soft" data-id="element-191" data-mp="jky8xtpkcrvd">
            Precio de hoy
          </p>
          <p className="mt-3 text-5xl font-extrabold tracking-tight text-white sm:text-6xl" data-id="element-192" data-mp="yuuzvhbl05te">
            33.990$
          </p>
          <p className="mt-3 text-sm text-white/60" data-id="element-193" data-mp="q19kbvrlekix">
            Pago único. Todo esto disponible de forma inmediata, para que
            empieces hoy mismo.
          </p>

          <div className="mt-7" data-id="element-194" data-mp="l3zwulnrkixq">
            <CTAButton checkout label="COMPRAR AHORA CON MERCADO PAGO" className="items-center" note="Paga con Mercado Pago · Acceso inmediato vía mail" data-id="element-195" data-mp="1hs5xkxhker6q" />
          </div>
        </div>
      </div>
    </Section>;
}